import { useState, useEffect } from 'react';
import { Message } from '@base/lib/Message';
import { api } from 'base/utils/api';

export type IAgeGateInstance = {
    age?: number;
    loading: boolean;
};

export function useAgeGate(): IAgeGateInstance {
    const [age, setAge] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);

    const getAge = async () => {
        setLoading(true);
        try {
            const res = await api.get('/web/minor/age/country');
            setAge(res.age);
        } catch (e) {
            Message.error(e.message);
        }
        setLoading(false);
    };

    useEffect(() => {
        getAge();
    }, []);

    return {
        age,
        loading,
    }
}
